<template>
  <div
    class="container d-flex justify-content-center align-items-center body">
    <slot />
  </div>
</template>
